import React, { useMemo } from 'react';

import { useAppSelector } from '@src/core/hooks';
import { useWidgetId } from '@src/core/IdProvider';
import { tariffsState } from '@src/features/product';
import { ScheduleTime } from '@src/core/buyerApiClient';
import { scheduleIsAvailable, splitHourList } from '@src/common/tariffs';
import TimeSelector from '@src/components/reusable/TimeSelector';

type Props = {
  time?: ScheduleTime;
  scheduleTimes?: ScheduleTime[];
  onSelectTime: (time: ScheduleTime) => void;
};

const TimeContainer = (props: Props) => {
  const { time, scheduleTimes, onSelectTime } = props;
  const widgetId = useWidgetId();
  const tariffsInformation = useAppSelector(tariffsState(widgetId));

  const hoursList = useMemo(
    () =>
      scheduleTimes?.map((hour) => ({
        hour,
        error: !scheduleIsAvailable(tariffsInformation, hour.minutes),
      })),
    [scheduleTimes, tariffsInformation],
  );

  const [morningTime, nightTime] = splitHourList(hoursList!);

  return (
    <TimeSelector onSelectTime={onSelectTime} morningTimes={morningTime!} nightTimes={nightTime!} selectedTime={time} />
  );
};

export default TimeContainer;
